/**
 * Created by stephane on 03.10.23.
 * © 2012 - 2021 Xample SA
 */

import {getCatalogBtn, handleSubmitCb} from "./helper/helpers";

const SubscribeFreeButton = (props) => {
    const productButton = getCatalogBtn();
    let product = props.product;
    return (
        <React.Fragment>
            <form className="buy_addon_form_class" onSubmit={(e) => handleSubmitCb(e, product, freeSubscriptionWithPlan, true)}>
                <input type="hidden" name="addon_key" value={product.key} readOnly />
                <button className={productButton}>{ gettext("Subscribe for free") }</button>
            </form>
        </React.Fragment>)
};
export default SubscribeFreeButton;
